var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-curriculum-vitae mt-12"},[_c('h2',{staticClass:"m-0 mb-10 text-6"},[_vm._v("Experience")]),_vm._v(" "),_c('lazy-hydrate',{attrs:{"ssr-only":""}},[_c('position-list',{attrs:{"positions":_vm.positions}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }